import { useState } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './ContactPage.css';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '', honeypot: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.name || !form.email || !form.subject || !form.message) {
      setError('Lütfen tüm alanları doldurun.');
      return;
    }

    if (form.message.length < 10) {
      setError('Mesaj en az 10 karakter olmalıdır.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Gönderilirken bir hata oluştu.');
    }
    setLoading(false);
  };

  return (
    <div className="contact-page">
      <Navigation />
      <div className="contact-container">
        <div className="contact-header">
          <h1>İletişim</h1>
          <p>Sorularınız, önerileriniz veya geri bildirimleriniz için bize ulaşın.</p>
        </div>

        <div className="contact-card">
          {success ? (
            <div className="contact-success">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3>Mesajınız Gönderildi</h3>
              <p>En kısa sürede size dönüş yapılacaktır. Teşekkür ederiz.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && <div className="contact-error">{error}</div>}

              {/* Honeypot - bot tuzağı, kullanıcı görmez */}
              <input
                type="text"
                name="honeypot"
                value={form.honeypot}
                onChange={(e) => setForm({ ...form, honeypot: e.target.value })}
                className="contact-honeypot"
                tabIndex="-1"
                autoComplete="off"
              />

              <div className="contact-form-group">
                <label>Ad Soyad</label>
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Adınız ve soyadınız"
                  maxLength={100}
                />
              </div>

              <div className="contact-form-group">
                <label>E-posta</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="ornek@email.com"
                  maxLength={100}
                />
              </div>

              <div className="contact-form-group">
                <label>Konu</label>
                <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}>
                  <option value="">Konu seçin...</option>
                  <option value="Genel Soru">Genel Soru</option>
                  <option value="Teknik Destek">Teknik Destek</option>
                  <option value="Öneri">Öneri</option>
                  <option value="İş Birliği">İş Birliği</option>
                  <option value="Hata Bildirimi">Hata Bildirimi</option>
                  <option value="Diğer">Diğer</option>
                </select>
              </div>

              <div className="contact-form-group">
                <label>Mesaj</label>
                <textarea
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="Mesajınızı buraya yazın..."
                  maxLength={2000}
                  rows={5}
                />
                <div className="contact-char-count">{form.message.length} / 2000</div>
              </div>

              <button type="submit" className="contact-submit" disabled={loading}>
                {loading ? 'Gönderiliyor...' : 'Mesaj Gönder'}
              </button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
